export function timeToOverviewX(timeMs, totalDurationMs, width) {
  const duration = Math.max(1, Number(totalDurationMs) || 0)
  return clamp(Number(timeMs) / duration * Math.max(0, Number(width) || 0), 0, Math.max(0, Number(width) || 0))
}

export function durationToOverviewWidth(durationMs, totalDurationMs, width, minimumWidth = 1) {
  const duration = Math.max(1, Number(totalDurationMs) || 0)
  return Math.max(Number(minimumWidth) || 0, Math.max(0, Number(durationMs) || 0) / duration * Math.max(0, Number(width) || 0))
}

export function overviewXToTime(x, width, totalDurationMs) {
  const overviewWidth = Math.max(1, Number(width) || 0)
  return clamp(Number(x) || 0, 0, overviewWidth) / overviewWidth * Math.max(0, Number(totalDurationMs) || 0)
}

export function overviewViewportGeometry({ scrollLeft, viewportWidth, contentWidth, overviewWidth }) {
  const width = Math.max(0, Number(overviewWidth) || 0)
  const content = Math.max(1, Number(contentWidth) || 0)
  const viewport = clamp(Number(viewportWidth) || 0, 0, content)
  const maxScroll = Math.max(0, content - viewport)
  return {
    left: maxScroll > 0 ? clamp(Number(scrollLeft) || 0, 0, maxScroll) / content * width : 0,
    width: Math.min(width, Math.max(2, viewport / content * width)),
  }
}

export function overviewXToScrollLeft(x, overviewWidth, contentWidth, viewportWidth) {
  const width = Math.max(1, Number(overviewWidth) || 0)
  const content = Math.max(1, Number(contentWidth) || 0)
  const viewport = clamp(Number(viewportWidth) || 0, 0, content)
  const targetCenter = clamp(Number(x) || 0, 0, width) / width * content
  return clamp(targetCenter - viewport / 2, 0, Math.max(0, content - viewport))
}

export function buildOverviewLaneGeometry(trackCount, height) {
  const count = Math.max(0, Math.trunc(Number(trackCount) || 0))
  const laneHeight = count > 0 ? Math.max(0, Number(height) || 0) / count : 0
  return Array.from({ length: count }, (_, trackIndex) => ({
    trackIndex,
    y: trackIndex * laneHeight,
    height: laneHeight,
  }))
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value))
}
